<template>
  <v-subheader>
    {{ name }}
  </v-subheader>
</template>

<script>
import { EventBus } from '@/services/event-bus'

  export default {
    props: ['name'],
    methods: {
      saveTemplate() {
        EventBus.$emit('save-template', 'SAVE THE STRING')
      }
    }
  }
</script>

<style scoped>

</style>